<template>
  <div>
    <v-card>
      <v-card-title>
        İçerik Kampanyaları
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Ara" single-line hide-details></v-text-field>
        <v-btn text color="primary" class="ml-4" @click="goBrandPortals">
          <v-icon left>mdi-chart-box-outline</v-icon> Marka Raporları
        </v-btn>
        <v-btn color="primary" class="ml-2" @click="openCreate">
          <v-icon left>mdi-plus</v-icon> Yeni
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :server-items-length="totalCount"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      >
        <template v-slot:item.publicUrl="{ item }">
          <v-btn small text color="primary" @click="copyUrl(item.slug)">
            <v-icon left small>mdi-link</v-icon> /c/{{ item.slug }}
          </v-btn>
        </template>
        <template v-slot:item.startDate="{ item }">
          {{ item.startDate | formatDate }}
        </template>
        <template v-slot:item.isPublic="{ item }">
          <v-chip x-small :color="item.isPublic ? 'success' : 'grey lighten-1'" text-color="white">
            {{ item.isPublic ? "Herkese açık" : "Davetli" }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn small text color="primary" @click="goInfluencers(item.id)">
            <v-icon left small>mdi-account-multiple</v-icon> Influencer'lar ({{ item.influencerCount }})
          </v-btn>
          <v-btn small text color="primary" @click="goAgencies(item.id)">
            <v-icon left small>mdi-domain</v-icon> Ajanslar
          </v-btn>
          <v-btn icon small @click="openEdit(item.id)"><v-icon small>mdi-pencil</v-icon></v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="sendStatsReminder(item)">
                <v-list-item-icon class="mr-2"><v-icon small>mdi-email-alert-outline</v-icon></v-list-item-icon>
                <v-list-item-title>İstatistik hatırlatma maili</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create / Edit dialog -->
    <v-dialog v-model="dialog" max-width="640" persistent>
      <v-card>
        <v-card-title>{{ form.id ? "Kampanyayı Düzenle" : "Yeni Kampanya" }}</v-card-title>
        <v-card-text>
          <v-form ref="formRef">
            <v-select v-model="form.companyId" :items="companies" item-text="name" item-value="id" label="Marka (Company)" :rules="[requiredError]"></v-select>
            <v-text-field v-model="form.name" label="Kampanya Adı" :rules="[requiredError]"></v-text-field>
            <label class="v-label theme--light caption mb-1 d-block" style="font-size:12px;color:rgba(0,0,0,.6);">Brief / Açıklama</label>
            <VueEditor v-model="form.briefText" :editor-toolbar="briefToolbar" class="mb-5" />

            <div class="d-flex gap-2">
              <v-menu v-model="startMenu" :close-on-content-click="false" min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="form.startDate" label="Başlangıç" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="form.startDate" @input="startMenu = false"></v-date-picker>
              </v-menu>
              <v-menu v-model="endMenu" :close-on-content-click="false" min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="form.endDate" label="Bitiş (ops.)" readonly v-on="on" class="ml-3"></v-text-field>
                </template>
                <v-date-picker v-model="form.endDate" @input="endMenu = false"></v-date-picker>
              </v-menu>
            </div>
            <v-menu v-model="publishMenu" :close-on-content-click="false" min-width="auto">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="form.publishDate" label="Yayınlanma Tarihi" prepend-icon="mdi-calendar-star" readonly clearable v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.publishDate" @input="publishMenu = false"></v-date-picker>
            </v-menu>
            <v-text-field v-model="form.requiredHashtags" label="Hashtag'ler (#kampanya #marka)"></v-text-field>
            <v-text-field v-model="form.requiredMentions" label="Mention (@marka)"></v-text-field>
            <v-text-field v-model="form.requiredUrl" label="Eklenecek URL"></v-text-field>
            <v-text-field
              v-model="form.draftUrlLabel"
              label="İlk içerik URL açıklaması"
              hint="İlk içerik yüklerken influencer'dan istenecek URL için açıklama (ör. 'Hikaye / Reels linkini gir'). Boş bırakılırsa URL alanı gösterilmez."
              persistent-hint
              class="mb-3"
            ></v-text-field>

            <v-switch
              v-model="form.isPublic"
              label="Herkese açık kampanya (mobil uygulamada listelensin)"
              hint="Açıkken kampanya Fantaslink mobil uygulamasındaki 'Keşfet' listesinde tüm kullanıcılara görünür ve doğrudan başvurabilirler. Kapalıyken kampanya yalnızca public link, Excel listesi veya ajans üzerinden yürür."
              persistent-hint
              class="mt-0 mb-4"
            ></v-switch>

            <v-file-input v-model="briefFile" label="Brief medyası (resim/video, opsiyonel)" accept="image/*,video/*" prepend-icon="mdi-paperclip"></v-file-input>
            <div v-if="form.briefMediaUrl" class="caption mb-2">Mevcut medya: <a :href="form.briefMediaUrl" target="_blank">görüntüle</a></div>

            <v-file-input v-model="docFile" label="Brief dökümanı (PDF, opsiyonel)" accept="application/pdf,.pdf" prepend-icon="mdi-file-pdf-box"></v-file-input>
            <div v-if="form.briefDocumentUrl" class="caption">Mevcut döküman: <a :href="form.briefDocumentUrl" target="_blank">indir / görüntüle</a></div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">İptal</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import NucleusComponentBase from "@/shared/application/nucleus-component-base";
import { Component, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";

@Component({ components: { VueEditor } })
export default class ContentCampaignList extends NucleusComponentBase {
  briefToolbar = [
    [{ header: [false, 1, 2, 3] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ];

  refs = this.$refs as any;
  loading = true;
  saving = false;
  dialog = false;
  startMenu = false;
  endMenu = false;
  publishMenu = false;
  search = "";
  options: any = {};
  items: any[] = [];
  totalCount = 0;
  companies: any[] = [];
  briefFile: File | null = null;
  docFile: File | null = null;

  form: any = {};

  headers = [
    { text: "Ad", value: "name" },
    { text: "Marka", value: "companyName" },
    { text: "Erişim", value: "isPublic", sortable: false },
    { text: "Public URL", value: "publicUrl", sortable: false },
    { text: "Başlangıç", value: "startDate" },
    { text: "", value: "actions", sortable: false, align: "end" },
  ];

  @Watch("options")
  onOptions() {
    this.getCampaigns();
  }

  @Watch("search")
  onSearch() {
    this.getCampaigns();
  }

  mounted() {
    this.getCompanies();
    this.getCampaigns();
  }

  async getCompanies() {
    const res = await this.nucleusService.get<any>(`/api/Companies?PageSize=1000`);
    if (!res.isError) this.companies = res.content.items || [];
  }

  async getCampaigns() {
    this.loading = true;
    const { page = 1, itemsPerPage = 10 } = this.options;
    const q = this.queryString.stringify({
      PageIndex: page - 1,
      PageSize: itemsPerPage,
      Filter: this.search,
    });
    const res = await this.nucleusService.get<any>(`/api/ContentCampaigns?${q}`);
    if (!res.isError) {
      this.items = res.content.items || [];
      this.totalCount = res.content.totalCount || 0;
    }
    this.loading = false;
  }

  openCreate() {
    // Yeni kampanya varsayılan olarak kapalıdır; keşfet listesine düşmesi admin'in bilinçli tercihi olmalı.
    this.form = { startDate: new Date().toISOString().substr(0, 10), isPublic: false };
    this.briefFile = null;
    this.docFile = null;
    this.dialog = true;
  }

  async openEdit(id: string) {
    const res = await this.nucleusService.get<any>(`/api/ContentCampaigns/${id}`);
    if (!res.isError) {
      const c = res.content;
      this.form = {
        id: c.id,
        companyId: c.companyId,
        name: c.name,
        briefText: c.briefText,
        briefMediaUrl: c.briefMediaUrl,
        briefDocumentUrl: c.briefDocumentUrl,
        requiredHashtags: c.requiredHashtags,
        requiredMentions: c.requiredMentions,
        requiredUrl: c.requiredUrl,
        draftUrlLabel: c.draftUrlLabel,
        isPublic: c.isPublic,
        startDate: c.startDate ? c.startDate.substr(0, 10) : "",
        endDate: c.endDate ? c.endDate.substr(0, 10) : "",
        publishDate: c.publishDate ? c.publishDate.substr(0, 10) : "",
      };
      this.briefFile = null;
      this.docFile = null;
      this.dialog = true;
    }
  }

  async save() {
    if (!this.refs.formRef.validate()) return;
    this.saving = true;
    try {
      // 1) kampanyayı kaydet (id al)
      let res = await this.nucleusService.post<any>(`/api/ContentCampaigns`, this.form);
      if (res.isError) throw new Error();
      const id = res.content.id;

      // 2) dosyalar seçildiyse yükle, url'leri kampanyaya işle
      let needsResave = false;
      if (this.briefFile) {
        const fd = new FormData();
        fd.append("file", this.briefFile);
        const up = await this.nucleusService.postExcel<any>(`/api/ContentCampaigns/${id}/brief`, fd);
        if (!up.isError && up.content && up.content.url) {
          this.form.briefMediaUrl = up.content.url;
          needsResave = true;
        }
      }
      if (this.docFile) {
        const fd = new FormData();
        fd.append("file", this.docFile);
        const up = await this.nucleusService.postExcel<any>(`/api/ContentCampaigns/${id}/brief`, fd);
        if (!up.isError && up.content && up.content.url) {
          this.form.briefDocumentUrl = up.content.url;
          needsResave = true;
        }
      }
      if (needsResave) {
        this.form.id = id;
        await this.nucleusService.post<any>(`/api/ContentCampaigns`, this.form);
      }

      this.swalToast(2000, "success", "Kaydedildi");
      this.dialog = false;
      this.getCampaigns();
    } catch {
      this.swalToast(2500, "error", "Kayıt başarısız");
    } finally {
      this.saving = false;
    }
  }

  goAgencies(id: string) {
    this.$router.push(`/admin/content-campaigns/${id}/agencies`);
  }

  goBrandPortals() {
    this.$router.push("/admin/content-campaigns/brand-portals");
  }

  goInfluencers(id: string) {
    this.$router.push(`/admin/content-campaigns/${id}/influencers`);
  }

  async sendStatsReminder(item: any) {
    const result = await this.swalConfirm(
      `"${item.name}" kampanyasında yayını geçmiş ama istatistik yüklememiş influencer'lara hatırlatma maili gönderilsin mi?`
    );
    if (!result.value) return;

    const res = await this.nucleusService.post<any>(`/api/ContentCampaigns/${item.id}/stats-reminder`, {});
    if (res.isError) {
      this.swalToast(2500, "error", "Mail gönderilemedi");
      return;
    }
    const { sent = 0, total = 0 } = res.content || {};
    if (total === 0) this.swalToast(2500, "info", "Hatırlatma gönderilecek influencer bulunamadı");
    else this.swalToast(2500, "success", `${sent}/${total} influencer'a hatırlatma maili gönderildi`);
  }

  copyUrl(slug: string) {
    const url = `${window.location.origin}/c/${slug}`;
    navigator.clipboard.writeText(url);
    this.swalToast(1500, "success", "Link kopyalandı");
  }
}
</script>
